/**
 * @fileoverview gRPC-Web generated client stub for keyvalue
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.31.0
// source: keyvalue.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.keyvalue = require('./keyvalue_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.keyvalue.KeyValueServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.keyvalue.KeyValueServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.keyvalue.GetRequest,
 *   !proto.keyvalue.GetResponse>}
 */
const methodDescriptor_KeyValueService_GetValue = new grpc.web.MethodDescriptor(
  '/keyvalue.KeyValueService/GetValue',
  grpc.web.MethodType.UNARY,
  proto.keyvalue.GetRequest,
  proto.keyvalue.GetResponse,
  /**
   * @param {!proto.keyvalue.GetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.keyvalue.GetResponse.deserializeBinary
);


/**
 * @param {!proto.keyvalue.GetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.keyvalue.GetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.keyvalue.GetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.keyvalue.KeyValueServiceClient.prototype.getValue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/keyvalue.KeyValueService/GetValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_GetValue,
      callback);
};


/**
 * @param {!proto.keyvalue.GetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.keyvalue.GetResponse>}
 *     Promise that resolves to the response
 */
proto.keyvalue.KeyValueServicePromiseClient.prototype.getValue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/keyvalue.KeyValueService/GetValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_GetValue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.keyvalue.InsertRequest,
 *   !proto.keyvalue.InsertResponse>}
 */
const methodDescriptor_KeyValueService_InsertValue = new grpc.web.MethodDescriptor(
  '/keyvalue.KeyValueService/InsertValue',
  grpc.web.MethodType.UNARY,
  proto.keyvalue.InsertRequest,
  proto.keyvalue.InsertResponse,
  /**
   * @param {!proto.keyvalue.InsertRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.keyvalue.InsertResponse.deserializeBinary
);


/**
 * @param {!proto.keyvalue.InsertRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.keyvalue.InsertResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.keyvalue.InsertResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.keyvalue.KeyValueServiceClient.prototype.insertValue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/keyvalue.KeyValueService/InsertValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_InsertValue,
      callback);
};


/**
 * @param {!proto.keyvalue.InsertRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.keyvalue.InsertResponse>}
 *     Promise that resolves to the response
 */
proto.keyvalue.KeyValueServicePromiseClient.prototype.insertValue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/keyvalue.KeyValueService/InsertValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_InsertValue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.keyvalue.AddRequest,
 *   !proto.keyvalue.AddResponse>}
 */
const methodDescriptor_KeyValueService_AddValue = new grpc.web.MethodDescriptor(
  '/keyvalue.KeyValueService/AddValue',
  grpc.web.MethodType.UNARY,
  proto.keyvalue.AddRequest,
  proto.keyvalue.AddResponse,
  /**
   * @param {!proto.keyvalue.AddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.keyvalue.AddResponse.deserializeBinary
);


/**
 * @param {!proto.keyvalue.AddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.keyvalue.AddResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.keyvalue.AddResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.keyvalue.KeyValueServiceClient.prototype.addValue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/keyvalue.KeyValueService/AddValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_AddValue,
      callback);
};


/**
 * @param {!proto.keyvalue.AddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.keyvalue.AddResponse>}
 *     Promise that resolves to the response
 */
proto.keyvalue.KeyValueServicePromiseClient.prototype.addValue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/keyvalue.KeyValueService/AddValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_AddValue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.keyvalue.UpdateRequest,
 *   !proto.keyvalue.UpdateResponse>}
 */
const methodDescriptor_KeyValueService_UpdateValue = new grpc.web.MethodDescriptor(
  '/keyvalue.KeyValueService/UpdateValue',
  grpc.web.MethodType.UNARY,
  proto.keyvalue.UpdateRequest,
  proto.keyvalue.UpdateResponse,
  /**
   * @param {!proto.keyvalue.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.keyvalue.UpdateResponse.deserializeBinary
);


/**
 * @param {!proto.keyvalue.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.keyvalue.UpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.keyvalue.UpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.keyvalue.KeyValueServiceClient.prototype.updateValue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/keyvalue.KeyValueService/UpdateValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_UpdateValue,
      callback);
};


/**
 * @param {!proto.keyvalue.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.keyvalue.UpdateResponse>}
 *     Promise that resolves to the response
 */
proto.keyvalue.KeyValueServicePromiseClient.prototype.updateValue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/keyvalue.KeyValueService/UpdateValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_UpdateValue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.keyvalue.DeleteRequest,
 *   !proto.keyvalue.DeleteResponse>}
 */
const methodDescriptor_KeyValueService_DeleteValue = new grpc.web.MethodDescriptor(
  '/keyvalue.KeyValueService/DeleteValue',
  grpc.web.MethodType.UNARY,
  proto.keyvalue.DeleteRequest,
  proto.keyvalue.DeleteResponse,
  /**
   * @param {!proto.keyvalue.DeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.keyvalue.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.keyvalue.DeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.keyvalue.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.keyvalue.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.keyvalue.KeyValueServiceClient.prototype.deleteValue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/keyvalue.KeyValueService/DeleteValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_DeleteValue,
      callback);
};


/**
 * @param {!proto.keyvalue.DeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.keyvalue.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.keyvalue.KeyValueServicePromiseClient.prototype.deleteValue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/keyvalue.KeyValueService/DeleteValue',
      request,
      metadata || {},
      methodDescriptor_KeyValueService_DeleteValue);
};


module.exports = proto.keyvalue;

